import React, { useState } from "react";
import useDocumentMeta from "../hooks/useDocumentMeta";
import { submitDataDeletionRequest } from "../lib/api";

const DataDeletionRequest = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useDocumentMeta({
    title: "FindClarity Data Deletion Request",
    description:
      "Request deletion of your FindClarity personal data by submitting your phone number.",
  });

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setMessage("");
    setError("");

    try {
      await submitDataDeletionRequest({ phone_number: phoneNumber });
      setMessage(
        "Your request has been received. We will delete your personal and related account data within seven working days.",
      );
      setPhoneNumber("");
    } catch (requestError) {
      setError(
        requestError?.response?.data?.detail ||
          "We could not submit your request right now. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="legal-page-container data-deletion-page">
      <div className="legal-content data-deletion-content">
        <h1 className="legal-title">Request Data Deletion</h1>
        <p className="legal-updated">For FindClarity account and personal data removal requests</p>

        <section className="legal-section">
          <p className="legal-text">
            If you want your FindClarity data removed, submit the phone number
            linked to your account below. Once we receive your request, we will
            delete your personal information and all associated user data within
            seven working days.
          </p>
          <p className="legal-text">
            This includes your account-related personal data, conversations, and
            any other information associated with that phone number in our
            systems, subject to legal retention requirements where applicable.
          </p>
        </section>

        <section className="legal-section data-deletion-panel">
          <h2 className="legal-heading">Submit Your Request</h2>
          <form className="data-deletion-form" onSubmit={handleSubmit}>
            <label className="data-deletion-label" htmlFor="phone-number">
              Phone Number
            </label>
            <input
              id="phone-number"
              type="tel"
              className="data-deletion-input"
              value={phoneNumber}
              onChange={(event) => setPhoneNumber(event.target.value)}
              placeholder="Enter your registered phone number"
              autoComplete="tel"
              required
            />
            <button
              type="submit"
              className="data-deletion-button"
              disabled={submitting}
            >
              {submitting ? "Submitting..." : "Request Data Deletion"}
            </button>
          </form>

          {message && <p className="data-deletion-success">{message}</p>}
          {error && <p className="data-deletion-error">{error}</p>}
        </section>
      </div>
    </div>
  );
};

export default DataDeletionRequest;
